import { envRootLocalizedDomain } from "@/utils";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FooterLinks extends Vue {
  get imprintUrl(): string {
    return `${envRootLocalizedDomain()}/imprint/`;
  }

  get privacyUrl(): string {
    return `${envRootLocalizedDomain()}/privacy/`;
  }

  get termsUrl(): string {
    return `${envRootLocalizedDomain()}/terms/`;
  }
}
